import IcDiscord from "../images/icons/ic-discord.svg";
import IcInstagram from "../images/icons/ic-instagram.svg";
import IcOpensea from "../images/icons/ic-opensea.svg";
import IcTwitter from "../images/icons/ic-twitter.svg";

// eslint-disable-next-line import/prefer-default-export
export const SOCIAL_MEDIAS = [
  {
    icon: IcDiscord,
    name: "Discord Bear Tiger Club Merch Shop",
    url: "https://discord.com/invite/beartigerclub",
  },
  {
    icon: IcOpensea,
    name: "Opensea Bear Tiger Club Merch Shop",
    url: "https://opensea.io/tbtc",
  },
  {
    icon: IcTwitter,
    name: "Twitter Bear Tiger Club Merch Shop",
    url: "https://twitter.com/beartigerclub?s=21&t=3SqQJojXydEVMfrXkpVLPQ",
  },
  {
    icon: IcInstagram,
    name: "Instagram Bear Tiger Club Merch Shop",
    url: "https://www.instagram.com/beartigerclub/",
  },
];
